module.exports = __webpack_public_path__ + "img/mubadla_logo.b33c2e2a.jpeg";